import api from '@/apis/sa/sAInvoiceAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('sAInvoice', api);

const state = {
  ...crud.state,
  _config: {
    table: 'sa_invoice',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Update lại trường đã lập hóa đơn ngoài màn hình danh sách
   * @param {*} context
   * @param {*} res
   * NNLINH 17.10.2022
   */
  updatedIsInvoiceExported(context, res) {
    context.commit('updatedIsInvoiceExported', res);
  },
};
const mutations = {
  ...crud.mutations,
  /**
   * Update lại trường đã lập hóa đơn ngoài màn hình danh sách
   * @param {*} state
   * @param {*} id
   * NNLINH 17.10.2022
   */
  updatedIsInvoiceExported(state, id) {
    let keyField = state._config.field.key;
    for (let i = 0; i < state.items.length; i++) {
      let item = state.items[i];

      if (item[keyField] === id) {
        let itemNew = { ...item };
        itemNew.is_invoice_exported = true;
        Object.assign(item, itemNew);
        break;
      }
    }
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
